'use strict';
Object.defineProperty(exports, Symbol.toStringTag, {
    value: 'Module'
});
var isUnsafeProperty = require('../_internal/isUnsafeProperty.js');
var isPlainObject = require('../predicate/isPlainObject.js');
function merge(target, source) {
    var sourceKeys = Object.keys(source);
    for(var i = 0; i < sourceKeys.length; i++){
        var key = sourceKeys[i];
        if (isUnsafeProperty.isUnsafeProperty(key)) {
            continue;
        }
        var sourceValue = source[key];
        var targetValue = target[key];
        if (Array.isArray(sourceValue)) {
            if (Array.isArray(targetValue)) {
                target[key] = merge(targetValue, sourceValue);
            } else {
                target[key] = merge([], sourceValue);
            }
        } else if (isPlainObject.isPlainObject(sourceValue)) {
            if (isPlainObject.isPlainObject(targetValue)) {
                target[key] = merge(targetValue, sourceValue);
            } else {
                target[key] = merge({}, sourceValue);
            }
        } else if (targetValue === undefined || sourceValue !== undefined) {
            target[key] = sourceValue;
        }
    }
    return target;
}
exports.merge = merge;
